<template>
  <div v-if="productsLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
  <div v-if="productsError" class="mc-error">{{ productsError }}</div>
  <section v-if="productsLoaded" class="cr-section">
    <div class="cr-section__title">
      {{ title }}
    </div>
    <div class="cr-section__body">
      <div class="cr-products-slider">
        <swiper
            wrapperTag="ul"
            :modules="modules"
            :scrollbar="{ draggable: true, el: '.swiper-scrollbar'+uniqueId}"
            :pagination="false"
            class="cr-products-slider__wrapper swiper"
            wrapperClass="cr-products-slider__list swiper-wrapper">
          <swiper-slide v-for="item in products(type)" class="cr-products-slider__item swiper-slide" tag="li">
            <product-item :product="item" />
          </swiper-slide>
          <template v-slot:container-end><div :class="'swiper-scrollbar swiper-scrollbar'+uniqueId"></div></template>
        </swiper>
      </div>
    </div>
    <div class="cr-section__bottom">
      <router-link class="cr-button" :to="'/category/'+type+'/'">
                            <span class="cr-button__text">
                                Смотреть все {{ title }}
                            </span>
      </router-link>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import { Pagination, Navigation, Scrollbar } from 'swiper';
import ProductItem from './ProductItem.vue'
export default {
  data: () => ({
    modules: [Pagination, Navigation, Scrollbar],
    uniqueId: 'slider'
  }),
  props: {
    type: '',
    title: ''
  },
  created() {
    this.fetchProducts({id:this.$props.type, page: 1, withoutpage: true, first:false});
  },
  computed: {
    ...mapGetters('products_list', [
      'products',
      'productsLoading',
      'productsError',
      'productsLoaded'
    ]),
  },
  components: {
    Swiper,
    SwiperSlide,
    ProductItem
  },
  methods: {
    ...mapActions('products_list', [
      'fetchProducts'
    ]),
  },
}
</script>
